export default "__VITE_PUBLIC_ASSET__61fd1b2e__"